import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { SportIcon } from "@/components/SportIcon";
import { NotifyOnboarding } from "@/components/NotifyOnboarding";

const SPORTS = [
  { slug: "running", name: "Running" }, { slug: "trail-running", name: "Trail Running" },
  { slug: "cycling", name: "Cycling" }, { slug: "triathlon", name: "Triathlon" },
  { slug: "duathlon", name: "Duathlon" }, { slug: "fitness-racing", name: "Fitness Racing" },
];
const DISTANCES = ["5K", "10K", "15K", "21.1K", "42.2K", "Ultra"];

export default function Profile() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({
    name: user?.name || "", location: user?.location || "",
    preferred_sports: user?.preferred_sports || [], preferred_distances: user?.preferred_distances || [],
  });
  const [busy, setBusy] = useState(false);

  const toggle = (key, val) => setForm((f) => ({ ...f, [key]: f[key].includes(val) ? f[key].filter((x) => x !== val) : [...f[key], val] }));

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/users/me", form);
      setUser(data);
      toast.success("Profile updated");
      nav("/dashboard");
    } catch { toast.error("Could not update profile"); } finally { setBusy(false); }
  };

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <h1 className="font-display font-extrabold uppercase text-4xl text-slate-800">Profile & Preferences</h1>
        <div className="bg-white border border-slate-200 rounded-2xl p-6 mt-8 space-y-6">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="text-sm font-semibold text-slate-700">Name</label>
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="profile-name"
                className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" /></div>
            <div><label className="text-sm font-semibold text-slate-700">Email</label>
              <input value={user?.email} disabled className="mt-1 w-full border border-slate-200 bg-slate-50 rounded-lg px-4 py-3 text-slate-500" /></div>
          </div>
          <div><label className="text-sm font-semibold text-slate-700">Location</label>
            <input value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} placeholder="e.g. Kuala Lumpur" data-testid="profile-location"
              className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" /></div>
          <div>
            <label className="text-sm font-semibold text-slate-700">Preferred Sports</label>
            <div className="flex flex-wrap gap-2 mt-2">{SPORTS.map((s) => (
              <button key={s.slug} onClick={() => toggle("preferred_sports", s.slug)}
                className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium border ${form.preferred_sports.includes(s.slug) ? "bg-[#0a1420] text-white border-[#0a1420]" : "border-slate-300 text-slate-600"}`}>
                <SportIcon sport={s.slug} size={15} />{s.name}</button>))}</div>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700">Preferred Distances</label>
            <div className="flex flex-wrap gap-2 mt-2">{DISTANCES.map((d) => (
              <button key={d} onClick={() => toggle("preferred_distances", d)}
                className={`font-mono-data px-3 py-2 rounded-lg text-sm font-bold border ${form.preferred_distances.includes(d) ? "bg-[#0a1420] text-white border-[#0a1420]" : "border-slate-300 text-slate-600"}`}>{d}</button>))}</div>
          </div>
          <button onClick={save} disabled={busy} data-testid="profile-save"
            className="bg-[#22d3ee] text-[#0a1420] font-bold px-6 py-3 rounded-lg hover:bg-[#06b6d4] transition-colors disabled:opacity-60">{busy ? "Saving…" : "Save Changes"}</button>
        </div>

        <NotifyOnboarding />
      </div>
    </Layout>
  );
}
